import { render } from "./Project.vue?vue&type=template&id=3218cc91&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=3218cc91&lang=css&scoped=true"
import "./Project.vue?vue&type=style&index=1&id=3218cc91&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3218cc91"]])

export default __exports__